<div
    #mentionContainer
    class="ql-mention-list-container"
    style="display: none"
    sbClickOutside
    (sbClickOutside)="hideMentionList()">
    <div #mentionList class="ql-mention-list">
        @for (mentionItem of filteredMentionItems; track mentionItem.id; let index = $index) {
            <button
                class="dropdown-item"
                (click)="onItemClick($event, index)"
                [ngClass]="{ selected: mentionItem.isSelected }">
                @if (mentionItem.type === mentionTypeEnum.user) {
                    <div class="d-flex align-items-center mt-1 mb-1">
                        <sb-user-avatar
                            class="user-avatar-btn"
                            [user]="mentionItem.user"
                            [size]="'btn'"
                            [isNeedTooltip]="false">
                        </sb-user-avatar>
                        <div class="truncate">
                            <div class="truncate text-light">
                                <span class="truncate-name">
                                    {{ mentionItem.user.name | truncate: 20 }}
                                </span>
                                <small class="text-light"> {{ mentionItem.user.email }} </small>
                            </div>
                        </div>
                    </div>
                }

                @if (mentionItem.type === mentionTypeEnum.group) {
                    <div class="d-flex align-items-center mt-1 mb-1">
                        <span class="group-avatar d-flex justify-content-center align-items-center">
                            <sb-inline-svg
                                class="icon"
                                [url]="
                                    '/sb-tools/theme/images/Svg icons WEB/Settings icons/Users icon.svg'
                                "></sb-inline-svg>
                        </span>
                        <div class="truncate">
                            <div class="truncate text-light">
                                <span class="truncate-name">
                                    {{ mentionItem.group.name | truncate: 20 }}
                                </span>
                                <small class="text-light">
                                    ({{ mentionItem.group.userCount }} {{ 'members' | translate }} )
                                </small>
                            </div>
                        </div>
                    </div>
                }
            </button>
        }
    </div>
</div>
